export default (name: string) => {
  const tmp = name.split('/');
  return decodeURIComponent(tmp[tmp.length - 1].split('?')[0]);
};
